import _, {compact, every, filter, find, get, has, isArray, isEmpty, some, values,toPairs, toLower} from 'lodash';

export const isQuizAnswersForMentorship = (quizAnswers) => has(quizAnswers, 'menteeAnswers');

export const getSelfAnswers = (isLearningHub, quizAnswers) => {
  if (isLearningHub) return quizAnswers;
  return quizAnswers.userAnswer;
};

export const getPartnerAnswers = (quizAnswers) => {
  return quizAnswers.partnerDetails;
};

export const selfQuizAnswered = (role, quizAnswers, isLearningHub) => {
  return !isEmpty(!isLearningHub ? get(toPairs(getSelfAnswers(isLearningHub, quizAnswers)), '[0][1]', []) : quizAnswers);
};

export const quizIsFor = (quizRelevancy, person) => {
  const relevancy = toLower(quizRelevancy);
  return !relevancy || relevancy === 'both' || relevancy === toLower(person.role);
};

export const getPartnerName = (partnerDetails, id) => {
  const partner = find(partnerDetails, partner => partner.id === id);
  return get(partner, 'firstName') + " " + get(partner, 'lastName')
};

// A question with no option marked correct is ungraded and has no verdict to show.
export const quizAnswerVerdict = (question, quizAnswer) => {
  const correct = filter(get(question, 'answerOptions', []), option => option.isCorrect);
  if (isEmpty(correct)) return {graded: false};

  const given = get(quizAnswer, 'answer');
  const chosen = compact(isArray(given) ? given : [given]);
  const isCorrect =
    !isEmpty(chosen) && every(chosen, key => some(correct, option => option.key === key));

  return {graded: true, isCorrect, correct};
};
